import React, {useEffect} from "react";
import { motion } from "framer-motion";
import { Gift, Sparkles } from "lucide-react";
import Confetti from "react-confetti";
import { useNavigate } from "react-router-dom";

const ThankYouGift = () => {
  const navigate = useNavigate();
  useEffect(() => {

      localStorage.removeItem("voucherCart");
    localStorage.removeItem("recipientInfo");

  });
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-amber-50 via-white to-amber-100 overflow-hidden">
      {/* 🎉 Confetti */}
      <Confetti numberOfPieces={300} recycle={false} />

      {/* 🌟 Animated Gift Icon */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8, type: "spring" }}
        className="bg-amber-600 text-white rounded-full p-8 shadow-lg mb-6"
      >
        <Gift className="w-14 h-14" />
      </motion.div>

      {/* 🥳 Thank You Message */}
      <motion.h1
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-4xl sm:text-5xl font-extrabold text-amber-700 text-center"
      >
        Thank You!
      </motion.h1>

      {/* ✨ Subtext */}
      <motion.p
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="text-lg text-gray-600 mt-3 text-center max-w-md"
      >
        Your gift card is on its way. We’ve emailed the recipient with their voucher details!
      </motion.p>

      {/* 🌈 Decorative sparkles */}
      <motion.div
        className="absolute top-12 right-12 text-amber-400"
        animate={{ rotate: 360 }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      >
        <Sparkles size={40} />
      </motion.div>

      {/* 💛 Action Buttons */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="flex gap-4 mt-10"
      >
        <button
          onClick={() => navigate("/")}
          className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Go To Orders
        </button>
        <button
          onClick={() => navigate("/my-account")}
          className="border border-amber-600 text-amber-700 hover:bg-amber-50 px-6 py-3 rounded-full font-semibold transition"
        >
          View My Account
        </button>
      </motion.div>
    </div>
  );
};

export default ThankYouGift;
